import Hero from "../../components/Hero";
import ProtectionImage from "../../../assets/images/Protection1.jpg";
import ProtectionImage1 from "../../../assets/images/Protection 2.jpg";
import ProtectionImage2 from "../../../assets/images/Protection 3.jpg";
import "../../../css/pages/servicesPage.css";
import "../../../css/components/ProtectionGrid.css";
import "../../../css/components/ProtectionGridImage.css";

const Protection = () => {
  return (
    <div>
      <Hero
        backgroundImage={ProtectionImage}
        title="Protection"
        subtitle="OUR SERVICES"
      />
      <div className="landing-page">
        <div className="primary-container light">
          <div className="column align-center">
            <div className="title-semibold primary">Income Protection</div>

            <div className="content primary">
              This provides income where you are ill or injured and as a result
              your income through employment or your normal route stops. It is
              designed to replace most of your net income.
            </div>
            <div className="title-semibold primary">Critical Illness</div>
            <div className="content primary">
              Critical illness insurance pays out when one of the specified
              critical illnesses occurs. For example, following a heart attack,
              stroke, cancer or some other specifically defined critical
              illness.
            </div>
          </div>
        </div>
        <div className="divider align-center"/>
        <div className="light-row">
          <img
            src={ProtectionImage1}
            className="landing-page-image"
            alt="Landing Page 2"
          />
          <div className="column">
            <div className="title-semibold primary">
              Military Personnel Insurance
            </div>
            <div className="content primary">
              Military personnel usually require cover for:
              <ul className="military-insurance-list">
                <li>Kit</li>
                <li>Travel</li>
                <li>Life Insurance</li>
                <li>Critical Illness</li>
                <li>Income</li>
                <li>Personal Accidents</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="protection-grid">
          <div className="protection-grid-item primary">
            <div className="title-semibold">Life Assurance</div>
            <div className="content">
              This is cover that pays out on death. Some plans pay upon earlier
              confirmation of a terminal illness where the prognosis is death
              within 12 months. Proceeds can pay out as a lump sum or as annual
              amount for the remainder of the policy term.
            </div>
          </div>
          <div className="protection-grid-item white">
            <div className="title-semibold primary">Family Income Benefit</div>
            <div className="content primary">
              This cover will pay out if death occurs and provides an income per
              year for the term remaining on the policy. For example, for a
              20-year term, where the claim occurred after five years, there
              would be 15 annual payments made in total. Payments can paid out
              either monthly or annually.
            </div>
          </div>
          <div className="protection-grid-item white">
            <div className="title-semibold primary">
              Private Medical Insurance
            </div>
            <div className="content primary">
              This is insurance that pays the hospital or doctor for your
              treatment. It can include treatment in a private ward or getting
              seen earlier in an NHS ward. Some plans allow you to claim if you
              are not able to be seen by the NHS within a set period. Other
              plans may charge a little more and don’t have any relevance to NHS
              waiting times.
            </div>
          </div>
          <div className="protection-grid-item primary">
            <div className="title-semibold">Landlord Insurance</div>
            <div className="content">
              Landlord insurance is insurance for landlords to protect their
              property and themselves (i.e., their liability). Most landlords
              are required to take out landlord insurance for each property they
              rent out, but landlords with large rental property portfolios may
              be able to get single cover for all properties.
            </div>
          </div>
        </div>
        <img
          src={ProtectionImage2}
          className="protection-grid-image"
          alt="Landing Page 3"
        />
      </div>
    </div>
  );
};

export default Protection;
